import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { UserGroupComponent } from './user-group/user-group.component';
import { UsersGroupsComponent } from './users-groups.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        UserGroupComponent,
        UsersGroupsComponent
    ],
    entryComponents: [
        UserGroupComponent,
        UsersGroupsComponent
    ],
    exports: [
        UserGroupComponent,
        UsersGroupsComponent
    ]
})
export class UserGroupsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/users-groups/users-groups.module.ts